export const privacyTranslations = {
  privacyPolicy: {
    title: "سياسة الخصوصية",
    description: "خصوصيتك مهمة بالنسبة لنا. توضح هذه السياسة كيف نجمع ونستخدم ونحمي معلوماتك.",
    lastUpdated: "آخر تحديث:",
    sections: {
      informationCollection: {
        title: "المعلومات التي نجمعها",
        personalInfo: {
          title: "المعلومات الشخصية",
          content: "نقوم بجمع المعلومات التي تقدمها لنا مباشرة، مثل عند إنشاء حساب أو الاشتراك في النشرة الإخبارية أو الاتصال بنا للحصول على الدعم. قد يشمل ذلك اسمك وعنوان بريدك الإلكتروني ورقم هاتفك والمعلومات المهنية."
        },
        usageInfo: {
          title: "معلومات الاستخدام",
          content: "نقوم تلقائيًا بجمع معلومات حول كيفية استخدامك لخدماتنا، بما في ذلك عنوان IP ونوع المتصفح والصفحات التي تمت زيارتها وأنماط التفاعل لتحسين خدماتنا."
        }
      },
      informationUse: {
        title: "كيف نستخدم معلوماتك",
        items: [
          "توفير خدمات الاختبار ومنصة المجتمع والحفاظ عليها وتحسينها",
          "إرسال الإشعارات الفنية والتحديثات والاتصالات التسويقية",
          "الرد على تعليقاتك وأسئلتك وتقديم دعم العملاء",
          "مراقبة وتحليل الاتجاهات والاستخدام والأنشطة المتعلقة بخدماتنا"
        ]
      },
      informationSharing: {
        title: "مشاركة المعلومات والكشف عنها",
        intro: "لا نبيع أو نتبادل أو ننقل معلوماتك الشخصية إلى أطراف ثالثة دون موافقتك، إلا في الحالات التالية:",
        items: [
          "مقدمي الخدمات الذين يساعدون في عملياتنا",
          "الامتثال القانوني وحماية الحقوق",
          "عمليات نقل الأعمال أو عمليات الدمج",
          "بموافقتك الصريحة"
        ]
      },
      dataSecurity: {
        title: "أمان البيانات",
        content: "ننفذ تدابير أمنية فنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الكشف أو التدمير. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100٪."
      },
      yourRights: {
        title: "حقوقك",
        intro: "لديك الحق في:",
        items: [
          "الوصول إلى معلوماتك الشخصية وتحديثها",
          "طلب حذف بياناتك",
          "الانسحاب من الاتصالات التسويقية",
          "إمكانية نقل البيانات"
        ]
      },
      contact: {
        title: "اتصل بنا",
        content: "إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا على:",
        details: {
          email: "البريد الإلكتروني: privacy@qualitynexus.com",
          address: "العنوان: فريق خصوصية Quality Nexus",
          businessAddress: "[عنوان عملك]"
        }
      }
    }
  }
};